import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    // mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('@/views/invite'),
            meta: {
                keepAlive: true,
                title: "邀请好友"
            }
        },
        {
            path: '/invite-edit',
            name: 'inviteEdit',
            component: () => import('@/views/invite/edit'),
            meta: {
                keepAlive: true,
                title: "邀请好友"
            }
        },
        {
            path: '/invite-success',
            name: 'inviteSuccess',
            component: () => import('@/views/invite/success'),
            meta: {
                keepAlive: true,
                title: "邀请好友"
            }
        },
        {
            path: '/xdmapp',
            name: 'xdmapp',
            meta: {
                title: '享得美'
            },
            component: () => import('../views/download/index')
        },
        {
            path: '/tutorial',
            name: 'tutorial',
            meta: {
                title: '享得美-使用教程'
            },
            component: () => import('../views/tutorial/index')
        },


    ]
})

router.beforeEach((to, from, next) => {

    if (to.path === '/download.html' && to.query.source) {
        sessionStorage.setItem("source", to.query.source);
    }
    /*路由发生改变修改页面的title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js